<main>
  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
</main>
<!--<ai-ui-footer></ai-ui-footer>-->